module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOCAYAAAE52y4kAAAAAXNSR0IArs4c6QAAAEVJREFUOBFjZGBg+A/EuAEjUAq/Ctx6oTIEjSCogKAVBBXQwQqCbqC1gpHgR1qHIeXmUxwLFBtAuR9GTRgNgQEOgQHPBQCU8QkBbSI5CAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header_menu_black.png
// module id = wF1d
// module chunks = 32